import { render, staticRenderFns } from "./chapterOptions.vue?vue&type=template&id=af600456&scoped=true&"
import script from "./chapterOptions.vue?vue&type=script&lang=js&"
export * from "./chapterOptions.vue?vue&type=script&lang=js&"
import style0 from "./chapterOptions.vue?vue&type=style&index=0&id=af600456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af600456",
  null
  
)

export default component.exports